import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Form, Button } from "reactstrap";
import TextField from "../../../common/TextField";
import { toast } from "react-toastify";
import { useMutationRequestQuery } from "../../../../Hooks/useMutationRequestQuery";
import { createLeadSourceService } from "../../../../Services/CRMAdminServices/CRMLeadSourceService";
import { useSafeNavigate } from "../../../../Hooks/useSafeNavigate";

export default function AddLeadSource() {
    const queryClient = useQueryClient();
    const navigate = useSafeNavigate();
    const [formData, setFormData] = useState({ leadSource: "", commission: "" });
    const [formErrors, setFormErrors] = useState<any>({});

    const handleValueChange = (name: string, value: string) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setFormErrors((prevErrors: any) => ({
            ...prevErrors,
            [name]: "",
        }));
    };

    const { mutate: addLeadSource, isPending: isAdding } = useMutationRequestQuery(
        "addLeadSource",
        createLeadSourceService,
        {
            onSuccess: () => {
                toast.success("Lead Source added successfully.");
                navigate("/CRMLeadSource");
                queryClient.invalidateQueries({ queryKey: ["getAllLeadSources"] });
            },
            onError: () => {
                toast.error("Failed to add lead source.");
            },
        }
    );

    const handleSubmit = (e: any) => {
        e.preventDefault();
        let errors: any = {};
        if (!formData.leadSource) errors.leadSource = "Lead Source is required!";
        // if (!formData.commission) errors.commission = "Commission is required!";

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

        addLeadSource(formData);
    };

    return (
        <div className="px-4 py-4" style={{ minHeight: "300px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", backgroundColor: "#f9f9f9", borderRadius: "8px" }}>
            <Form style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", backgroundColor: "white", borderRadius: "8px", padding: "15px", paddingLeft: "30px" }}>
                <TextField
                    label="Lead Source:"
                    type="text"
                    name="leadSource"
                    value={formData.leadSource}
                    setValue={handleValueChange}
                    placeholder="Enter lead source"
                    passCol="col-4"
                    design="flex"
                    maxChars={50}
                    error={formErrors.leadSource}
                    errorMessage="Lead Source is required!"
                />
                {/* <TextField
                    label="Commission:"
                    type="text"
                    name="commission"
                    value={formData.commission}
                    setValue={handleValueChange}
                    placeholder="Enter commission"
                    passCol="col-4"
                    design="flex"
                    maxChars={10}
                    error={formErrors.commission}
                    errorMessage="Commission is required!"
                /> */}
                <div className="d-flex gap-3 mt-3">
                    <Button onClick={() => navigate("/CRMLeadSource")} color="secondary">Back to Lead Sources</Button>
                    <Button onClick={handleSubmit} color="primary" disabled={isAdding} type="submit">
                        {isAdding ? "Saving..." : "Save Lead Source"}
                    </Button>
                </div>
            </Form>
        </div>
    );
}
